import { render, staticRenderFns } from "./StudentAbsenceRequests.vue?vue&type=template&id=6824b9d5"
import script from "./StudentAbsenceRequests.vue?vue&type=script&lang=js"
export * from "./StudentAbsenceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports